import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#757575",
      d: "M9.362 18.153c6.056 0 9.356-5.025 9.356-9.356v-.42a6.6 6.6 0 0 0 1.64-1.703 7 7 0 0 1-1.892.525 3.32 3.32 0 0 0 1.45-1.829 6.6 6.6 0 0 1-2.08.799 3.26 3.26 0 0 0-2.397-1.051 3.293 3.293 0 0 0-3.301 3.3c0 .253.02.505.084.757A9.42 9.42 0 0 1 5.43 5.727a3.36 3.36 0 0 0-.442 1.64c0 1.136.589 2.145 1.472 2.734a3.24 3.24 0 0 1-1.493-.42v.041a3.27 3.27 0 0 0 2.65 3.217 3 3 0 0 1-.863.126c-.21 0-.42-.02-.61-.063a3.33 3.33 0 0 0 3.07 2.292 6.6 6.6 0 0 1-4.079 1.408c-.273 0-.525-.02-.778-.042a9.04 9.04 0 0 0 5.004 1.493"
    }, null, -1)
  ]))]))
}
export default { render: render }